import { render, staticRenderFns } from "./DeliveryStatusByManifest.vue?vue&type=template&id=48202f85&scoped=true&"
import script from "./DeliveryStatusByManifest.vue?vue&type=script&lang=js&"
export * from "./DeliveryStatusByManifest.vue?vue&type=script&lang=js&"
import style0 from "./DeliveryStatusByManifest.vue?vue&type=style&index=0&id=48202f85&lang=sass&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "48202f85",
  null
  
)

export default component.exports